const callToActionContent = {
  title: 'Agenda tu cita ahora para comenzar tu tratamiento',
}

export default callToActionContent
